<bp-hl-area-container name="Vegetationsaufnahme">
	<div class="touch-form">
		<!-- Schichtanteile Section -->
		<div class="form-section-header">Schichtanteile</div>
		<div class="form-row">
			<div class="form-input-cell multi equal-width">
				<div *ngFor="let sch of schichten()" class="schicht-summary">
					<span class="schicht-label">{{schichtLabel(sch)}}</span>
					<span class="schicht-value">{{data.bodenvegetation.aufnahme.schichtAnteile[sch] ?? '–'}}</span>
				</div>
			</div>
		</div>

		<!-- Vegetationstabelle Section -->
		<div class="form-section-header">Vegetation</div>
		<table class="table table-sm table-striped table-hover vegetation-table">
			<thead>
				<tr>
					<th>Schicht</th>
					<th class="w-75">Vegetation</th>
					<th class="w-25 text-right">%</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of data.bodenvegetation.aufnahme.vegetationen; let i = index">
					<td>
						<wd-list-input name="Vegetationsschicht[{{i}}]" [(model)]="row.schicht"></wd-list-input>
					</td>
					<td>
						<wd-typeahead name="Vegetation[{{i}}]" [(model)]="row.vegetation" placement="bottom-left bottom-right top-left top-right"></wd-typeahead>
					</td>
					<td><wd-text-input name="Vegetations-Anteil[{{i}}]" class="text-right" [(model)]="row.haeufigkeit"></wd-text-input></td>
					<td><button type="button" class="btn btn-danger btn-sm" (click)="onRemoveVegetationsZeile(i)"><bi name="trash"></bi></button></td>
				</tr>
				<tr>
					<td colspan="4">
						<button style="width: 100%" type="button" class="btn btn-info btn-sm" (click)="onAddVegetationsZeile()"><bi name="plus"></bi></button>
					</td>
				</tr>
			</tbody>
		</table>

		<div class="spacer-sm"></div>

		<!-- Humusform / Vegetationsformengruppe -->
		<div class="form-section-header">Humusform</div>
		<div class="form-row" *ngIf="hatHumusForm(data) || hatVegetationsformengruppe(data)">
			<div class="form-input-cell multi no-scroll">
				<wd-an-typeahead *ngIf="hatHumusForm(data)" name="Humusform" label="Humusform" [(model)]="data.header.humusform.aufnahmeFlaeche"></wd-an-typeahead>
				<wd-typeahead *ngIf="hatVegetationsformengruppe(data)" name="Vegetationsformengruppe" label="Veg.-Gruppe" [(model)]="data.header.vegetationsformengruppe"></wd-typeahead>
			</div>
		</div>

		<!-- Humusauflage Section -->
		<div class="form-section-header">Humusauflage</div>
		<div class="form-row">
			<div class="form-input-cell multi equal-width">
				<wd-number-input name="Ol" label="Ol [cm]" [(model)]="data.extendedHeader.humusAuflage.ol"></wd-number-input>
				<wd-number-input name="Of" label="Of [cm]" [(model)]="data.extendedHeader.humusAuflage.of"></wd-number-input>
				<wd-number-input name="Oh" label="Oh [cm]" [(model)]="data.extendedHeader.humusAuflage.oh"></wd-number-input>
			</div>
		</div>

		<!-- Bestand & Bemerkungen -->
		<div class="form-section-header">Bestand &amp; Bemerkungen</div>
		<div class="form-row" *ngIf="isString(data.extendedHeader.baumarten)">
			<div class="form-label-cell">Bestand</div>
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bestand" [(model)]="data.extendedHeader.baumarten"></wd-multiline-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Bemerkungen</div>
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
